import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { CompleteAnalyticsEvents } from "@qgiv/core-donor";
import {
    getDataLayerOptions,
    sendCompleteAnalyticsEvents,
} from "@qgiv/p2p-registration";
import { selectCurrentPage } from "../../redux/slices/currentPageSlice";
import { selectAppSettings } from "../../redux/slices/appSettingsSlice";
import { selectAllFormSettings } from "../../redux/slices/formSettingsSlice";
import { selectAllRegistration } from "../../redux/slices/registrationSlice";
import { selectReceipt } from "../../redux/slices/receiptSlice";

const ConnectedCompleteAnalyticsEvents = () => {
    const {
        ENUMS: {
            DefaultView: { STANDARD_REGISTRATION_RECEIPT },
        },
    } = constants;
    const appSettings = useSelector(selectAppSettings);
    const formSettings = useSelector(selectAllFormSettings);
    const registration = useSelector(selectAllRegistration);
    const currentPage = useSelector(selectCurrentPage);
    const receipt = useSelector(selectReceipt);
    const { hasSubmittedRegistration } = appSettings;

    // Generate all of the data that can be sent with payload
    const dataLayerOptions = getDataLayerOptions({
        formSettings,
        receipt,
        registration,
    });

    const hasSubmittedForm = hasSubmittedRegistration;
    const isConfirmationPage = currentPage === STANDARD_REGISTRATION_RECEIPT;

    const completeAnalyticsEventsProps = {
        dataLayerOptions,
        hasSubmittedForm,
        isConfirmationPage,
        sendCompleteAnalyticsEvents,
    };

    return <CompleteAnalyticsEvents {...completeAnalyticsEventsProps} />;
};

export default ConnectedCompleteAnalyticsEvents;
